import { lazy, Suspense } from 'react'
import { useAppStore } from '@/store/useAppStore.ts'
import { InputPanel } from '@/components/layout/InputPanel.tsx'
import { ResultsPanel } from '@/components/layout/ResultsPanel.tsx'
import { QuickMode } from '@/components/packbuilder/QuickMode.tsx'
import { ErrorBoundary } from '@/components/shared/ErrorBoundary.tsx'
import { LoadingFallback } from '@/components/shared/LoadingFallback.tsx'

const ScenarioTab = lazy(() => import('@/components/scenarios/ScenarioTab.tsx').then((m) => ({ default: m.ScenarioTab })))
const PackBuilderTab = lazy(() => import('@/components/packbuilder/PackBuilderTab.tsx').then((m) => ({ default: m.PackBuilderTab })))

export function MainLayout() {
  const activeTab = useAppStore((s) => s.activeTab)
  const quickModeActive = useAppStore((s) => s.quickModeActive)

  if (quickModeActive) {
    return (
      <main id="main-content" className="main-layout">
        <QuickMode />
      </main>
    )
  }

  return (
    <main id="main-content" className="main-layout">
      {activeTab === 'runtime' && (
        <div role="tabpanel" id="tabpanel-runtime" aria-labelledby="tab-runtime" className="main-layout__panel">
          <ErrorBoundary panelName="Runtime">
            <InputPanel />
            <ResultsPanel />
          </ErrorBoundary>
        </div>
      )}
      {activeTab === 'scenarios' && (
        <div role="tabpanel" id="tabpanel-scenarios" aria-labelledby="tab-scenarios">
          <ErrorBoundary panelName="Scenarios">
            <Suspense fallback={<LoadingFallback />}>
              <ScenarioTab />
            </Suspense>
          </ErrorBoundary>
        </div>
      )}
      {activeTab === 'packBuilder' && (
        <div role="tabpanel" id="tabpanel-packBuilder" aria-labelledby="tab-packBuilder">
          <ErrorBoundary panelName="Pack Builder">
            <Suspense fallback={<LoadingFallback />}>
              <PackBuilderTab />
            </Suspense>
          </ErrorBoundary>
        </div>
      )}
    </main>
  )
}
